import { ModuleWithProviders, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { LoggedGuard } from './guargs/logged.guard'
import { RolesGuard } from './guargs/roles.guard'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  exports: []
})

export class AuthModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AuthModule,
      providers: [
        RolesGuard,
        LoggedGuard,
      ],
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.module.ts